import request from '@/utils/request'
import { getCommunityId } from '@/utils/vc'

export function getStaffSnapshotList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/staffSnapshot.listStaffSnapshot',
      method: 'get',
      params: { ...params, communityId: getCommunityId() }
    }).then(response => { resolve(response.data) })
      .catch(error => { reject(error) })
  })
}

export function saveStaffSnapshot(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/staffSnapshot.saveStaffSnapshot',
      method: 'post',
      data: { ...data, communityId: getCommunityId() }
    }).then(response => { resolve(response.data) })
      .catch(error => { reject(error) })
  })
}

export function deleteStaffSnapshot(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/staffSnapshot.deleteStaffSnapshot',
      method: 'post',
      data: { ...data, communityId: getCommunityId() }
    }).then(response => { resolve(response.data) })
      .catch(error => { reject(error) })
  })
}
